import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/oxbull_stake.webm")